import { render } from "./StockInward.vue?vue&type=template&id=0c00b964&scoped=true"
import script from "./StockInward.vue?vue&type=script&lang=js"
export * from "./StockInward.vue?vue&type=script&lang=js"

import "./StockInward.vue?vue&type=style&index=0&id=0c00b964&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c00b964"]])

export default __exports__